import React from "react";
import styled from "styled-components";
import FormLabel from "./FormLabel";

const RadioContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

const Label = styled.label`
  font-family: "Roboto", sans-serif;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const Input = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
`;

const CustomRadio = styled.span`
  width: 20px;
  height: 20px;
  border: 2px solid ${({ checked }) => (checked ? "#0098db" : "#acacac")};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &::after {
    content: "";
    display: ${({ checked }) => (checked ? "block" : "none")};
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #0098db;
  }
`;

const Spacer = styled.div`
  width: 50px;
`;

const GenderRadioForm = ({ gender, setGender }) => {
  const handleChange = (event) => {
    setGender(event.target.value);
  };

  return (
    <div>
      <FormLabel>Género</FormLabel>
      <RadioContainer>
        <Label htmlFor="male">
          <Input
            type="radio"
            id="male"
            name="gender"
            value="Masculino"
            checked={gender === "Masculino"}
            onChange={handleChange}
          />
          <CustomRadio checked={gender === "Masculino"} />
          Masculino
        </Label>
        <Spacer />
        <Label htmlFor="female">
          <Input
            type="radio"
            id="female"
            name="gender"
            value="Femenino"
            checked={gender === "Femenino"}
            onChange={handleChange}
          />
          <CustomRadio checked={gender === "Femenino"} />
          Femenino
        </Label>
      </RadioContainer>
    </div>
  );
};

export default GenderRadioForm;
